import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_URL } from '../apiConfig'

export const assignAssetToUser = createAsyncThunk(
  'assignAssetToUser',
  async ({ jwt_token, requestBody }) => {
    console.log('Request Body - ', requestBody)
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + jwt_token,
        'Content-Type': 'application/json' // Set content type to JSON
      },
      body: JSON.stringify(requestBody) // Wrap requestBody as needed
    }

    try {
      const response = await fetch(
        `${BASE_URL}inventory/assign/asset/`,
        options
      )
      console.log('Request Options - ', options)
      console.log('Response -- ', response)
      console.log('Response Payload - ', response.status)
      return response.json() // Assuming the response is JSON
    } catch (error) {
      console.log('Error', error)
      alert(error.message)
      throw error
    }
  }
)

const assignAssetToUserSlice = createSlice({
  name: 'assignAssetToUser',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: null
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(assignAssetToUser.pending, state => {
      state.isLoading = true
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(assignAssetToUser.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(assignAssetToUser.rejected, (state, action) => {
      state.isLoading = false
      state.isError = true
      state.errorMessage = action.error.message
    })
  }
})

export default assignAssetToUserSlice.reducer
